import { render, staticRenderFns } from "./centerForm.vue?vue&type=template&id=3cf19837&scoped=true&"
import script from "./centerForm.vue?vue&type=script&lang=js&"
export * from "./centerForm.vue?vue&type=script&lang=js&"
import style0 from "./centerForm.vue?vue&type=style&index=0&id=3cf19837&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf19837",
  null
  
)

export default component.exports